import acousticGuitarImage from "@/public/images/instruments/acoustic-guitar.jpg";
import airyFluteImage from "@/public/images/instruments/airy-flute.jpg";
import bansuriImage from "@/public/images/instruments/bansuri.png";
import baritoneSaxImage from "@/public/images/instruments/baritone-sax.png";
import bassVocoderImage from "@/public/images/instruments/bass-vocoder.jpg";
import celloImage from "@/public/images/instruments/cello.png";
import cleanBassImage from "@/public/images/instruments/clean-bass.jpg";
import cleanGuitarImage from "@/public/images/instruments/clean-guitar.png";
import danceStringsImage from "@/public/images/instruments/dance-strings.jpg";
import darkCelloImage from "@/public/images/instruments/dark-cello.jpg";
import discoBassImage from "@/public/images/instruments/disco-bass.jpg";
import distortedBassImage from "@/public/images/instruments/distorted-bass.jpg";
import dudukImage from "@/public/images/instruments/duduk.jpg";
import edgeGuitarImage from "@/public/images/instruments/edge-guitar.jpg";
import electricGuitarImage from "@/public/images/instruments/electric-guitar.jpg";
import fluteImage from "@/public/images/instruments/flute.png";
import formantVocalEffectImage from "@/public/images/instruments/formant-vocal-effect.jpg";
import handPercussionSoftImage from "@/public/images/instruments/hand-percussion-soft.png";
import latinPulseDrumsImage from "@/public/images/instruments/latin-pulse-drums.jpg";
import minimalElectronicDrumsImage from "@/public/images/instruments/minimal-electronic-drums.jpg";
import mutedGuitarImage from "@/public/images/instruments/muted-guitar.jpg";
import partySaxImage from "@/public/images/instruments/party-saxophone.jpg";
import razorBassImage from "@/public/images/instruments/razor-bass.jpg";
import rockBassImage from "@/public/images/instruments/rock-bass.jpg";
import screamingGuitarImage from "@/public/images/instruments/screaming-guitar.jpg";
import snakeCharmerFluteImage from "@/public/images/instruments/snake-charmer-flute.png";
import tenorSaxophoneImage from "@/public/images/instruments/tenor-saxophone.jpg";
import tromboneImage from "@/public/images/instruments/trombone.png";
import trumpetImage from "@/public/images/instruments/trumpet.jpg";
import violinImage from "@/public/images/instruments/violin.png";
import wobbleBassImage from "@/public/images/instruments/wobble-bass.png";
import { Instrument } from "@/types/types";

export const instruments: Instrument[] = [
  {
    id: "1013",
    name: "Trombone",
    image: tromboneImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Ftrombone-preview.mp3",
  },
  {
    id: "1000",
    name: "Party Saxophone",
    image: partySaxImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fparty-sax-preview.mp3",
  },
  {
    id: "1012",
    name: "Acoustic Guitar",
    image: acousticGuitarImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Facoustic-guitar-preview.mp3",
  },
  {
    id: "241",
    name: "Disco Bass",
    image: discoBassImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fdisco-bass-preview.mp3",
  },
  {
    id: "1001",
    name: "Snake Charmer Flute",
    image: snakeCharmerFluteImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fsnake-charmer-flute-preview.mp3",
  },
  {
    id: "1002",
    name: "Clean Guitar",
    image: cleanGuitarImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fclean-guitar-preview.mp3",
  },
  {
    id: "253",
    name: "Baritone Sax",
    image: baritoneSaxImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fbaritone-sax-preview.mp3",
  },
  {
    id: "1003",
    name: "Bansuri",
    image: bansuriImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fbansuri-preview.mp3",
  },
  {
    id: "246",
    name: "Rock Bass",
    image: rockBassImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Frock-bass-preview.mp3",
  },
  {
    id: "242",
    name: "Screaming Guitar",
    image: screamingGuitarImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fscreaming-guitar-preview.mp3",
  },
  {
    id: "1004",
    name: "Flute",
    image: fluteImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fflute-preview.mp3",
  },
  {
    id: "1005",
    name: "Tenor Saxophone",
    image: tenorSaxophoneImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Ftenor-saxophone-preview.mp3",
  },

  {
    id: "1006",
    name: "Violin",
    image: violinImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fviolin-preview.mp3",
  },
  {
    id: "243",
    name: "Clean Bass",
    image: cleanBassImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fclean-bass-preview.mp3",
  },
  {
    id: "278",
    name: "Wobble Bass",
    image: wobbleBassImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fwobble-bass-preview.mp3",
  },
  {
    id: "1007",
    name: "Dance Strings",
    image: danceStringsImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fdance-strings-preview.mp3",
  },
  {
    id: "1008",
    name: "Cello",
    image: celloImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fcello-preview.mp3",
  },
  {
    id: "268",
    name: "Latin Pulse Drums",
    image: latinPulseDrumsImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Flatin-pulse-drums-preview.mp3",
  },
  {
    id: "1009",
    name: "Duduk",
    image: dudukImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fduduk-preview.mp3",
  },
  {
    id: "252",
    name: "Muted Guitar",
    image: mutedGuitarImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fmuted-guitar-preview.mp3",
  },
  {
    id: "1010",
    name: "Trumpet",
    image: trumpetImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Ftrumpet-preview.mp3",
  },
  {
    id: "1011",
    name: "Electric Guitar",
    image: electricGuitarImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Felectric-guitar-preview.mp3",
  },
  {
    id: "277",
    name: "Razor Bass",
    image: razorBassImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Frazor-bass-preview.mp3",
  },
  {
    id: "247",
    name: "Distorted Bass",
    image: distortedBassImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fdistorted-bass-preview.mp3",
  },
  {
    id: "236",
    name: "Bass Vocoder",
    image: bassVocoderImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fbass-vocoder-preview.mp3",
  },
  {
    id: "238",
    name: "Formant Vocal Effect",
    image: formantVocalEffectImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fformant-vocal-effect-preview.mp3",
  },
  {
    id: "266",
    name: "Airy Flute",
    image: airyFluteImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fairy-flute-preview.mp3",
  },
  {
    id: "270",
    name: "Hand Percussion Soft",
    image: handPercussionSoftImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fhand-percussion-soft-preview.mp3",
  },
  {
    id: "244",
    name: "Edge Guitar",
    image: edgeGuitarImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fedge-guitar-preview.mp3",
  },
  {
    id: "265",
    name: "Dark Cello",
    image: darkCelloImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fdark-cello-preview.mp3",
  },
  {
    id: "269",
    name: "Minimal Electronic Drums",
    image: minimalElectronicDrumsImage,
    description:
      "Try to mimic the sound of the instrument with your voice. Vocal samples without words, such as ad-libs, work great as input. You can also turn one instrument into another, for example, transforming a saxophone into a guitar.",
    previewUrl:
      "https://public-assets.audimeestorage.com/instrumentPreviews%2Fminimal-electronic-drums-preview.mp3",
  },
];
